import { createAsyncThunk } from '@reduxjs/toolkit';
import { _teleModPriceUrls } from '@custom/Utils/constants/apiUrls';

type payloadType = {
  pageNumber: number;
  limit: number;
  search: string;
};

// Async thunk to get all teleradiology modality prices
export const getTeleModPrices = createAsyncThunk(
  'getTeleModPrices',
    async (payload: payloadType, { rejectWithValue }) => {  // Note the underscore for unused payload parameter
    try {
      const token = sessionStorage.getItem('token') || localStorage.getItem('token');
      // if payload doesn't have search then don't pass it in the url
      const search = payload?.search === undefined ? '' : payload?.search;
      const response = await fetch(`${_teleModPriceUrls?.get}?page=${payload?.pageNumber}&limit=${payload?.limit}&search=${search}`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response?.ok) {
        return rejectWithValue(`Failed to fetch modality prices. Status code: ${response?.status}`);
      }

      return await response.json(); // Return the fetched data if successful
    } catch (error: any) {
      return rejectWithValue(error.message); // Handle any errors that occur
    }
  }
);

// You can export all thunks together if needed
export default getTeleModPrices;
